import { axios } from '@/utils/axios'
import { groupBy, orderBy } from 'lodash'
import { flightCities } from '@/assets/js/data'
import { getAirportName } from '@/assets/js/util'
import { orderStatusMap, travalerTypeMap, idTypeV2Map, segmentStatusMap, ticketStatusMap, payStatusMap, payTypeMap, refundStatusMap } from '@/dicts/order'
// 新版订单列表
export async function queryListNew (params) {
  try {
    const data = await axios({
      url: '/api/order/queryUserOrder',
      method: 'post',
      data: params
    })
    const airport = await flightCities()

    if (data && data.list) {
      data.list.forEach(element => {
        element.statusCn = orderStatusMap[element.status]

        element.segmentList.forEach(seg => {
          seg.depName = getAirportName(airport, seg.depCode)
          seg.arrName = getAirportName(airport, seg.arrCode)
        })
      })

      return data
    } else {
      return Promise.reject(new Error('订单数据异常'))
    }
  } catch (err) {
    return Promise.reject(err)
  }
}

// 新版订单详情
export async function queryDetailV2 (params) {
  try {
    const data = await axios({
      url: '/api/order/queryOrderDetail',
      method: 'post',
      data: params
    })

    if (data && data.offers) {
      data.offers.forEach(element => {
        element.detail.statusCn = orderStatusMap[element.detail.status]

        if (element.detail.itinerary) {
          element.detail.itinerary.statusCn = orderStatusMap[element.detail.itinerary.status]
        }

        element.detail.travelers.forEach(traveler => {
          traveler.typeCn = travalerTypeMap[traveler.type]
          traveler.certificateTypeCn = idTypeV2Map[traveler.certificateType]

          traveler.flightSegments.forEach(seg => {
            seg.statusCn = segmentStatusMap[seg.status]
            seg.ticketStatusCn = ticketStatusMap[seg.ticketStatus]
          })
          traveler.flightSegments = handleChangeSegmentFlag(traveler.flightSegments)

          traveler.infantTravelers?.forEach(infantTraveler => {
            infantTraveler.flightSegments?.forEach(seg => {
              seg.ticketStatusCn = ticketStatusMap[seg.ticketStatus]
            })
          })
        })

        element.detail.accompanyTicketList?.forEach(traveler => {
          traveler.fullName = traveler.passengerName
          traveler.certificateNo = traveler.certNo
          traveler.flightSegments = traveler.segs
        })

        element.detail.changes.forEach(change => {
          change.statusCn = orderStatusMap[change.status]
        })

        element.detail.payments.forEach(pay => {
          pay.payStatusCn = payStatusMap[pay.payStatus]
          pay.payTypeCn = payTypeMap[pay.payType]
        })

        element.detail.otherPayments?.forEach(pay => {
          pay.payStatusCn = payStatusMap[pay.payStatus]
          pay.payTypeCn = payTypeMap[pay.payType]
        })

        if (element.detail?.otherPayments?.length > 0) {
          element.detail.payments = element.detail.payments.concat(element.detail.otherPayments)
        }

        element.detail.refunds.forEach(refund => {
          refund.statusCn = refundStatusMap[refund.status]
        })

        element.detail.orderDuration = element.detail.orderLimit - new Date().getTime()
      })

      return data
    } else {
      return Promise.reject(new Error('订单详情数据异常'))
    }
  } catch (err) {
    return Promise.reject(err)
  }
}

// 新版订单取消
export async function cancelNew (params) {
  try {
    return await axios({
      url: '/api/order/cancelOrder',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 通用取消订单（支持卡券）-v2
export async function cancelOrderV2 (params) {
  try {
    return await axios({
      url: '/api/order/v2/cancelOrder',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 新版改升支持校验
export async function checkNew (params) {
  try {
    return await axios({
      url: '/api/change/order/can/flight',
      method: 'post',
      data: params,
      timeout: 300000
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 支付差错
export async function misPayNew (params) {
  try {
    return await axios({
      url: '/api/uniPayment/misPay',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 新版辅营订单退票
export async function refundNew (params) {
  const { type, orderIds } = params

  if (type === 'OTHER' || type === 'INSURANCE') {
    if (orderIds && orderIds.length) {
      params.orderItemServiceDetailIds = params.orderIds
    }
  }

  try {
    await axios({
      url: '/api/order/refundOrder',
      method: 'post',
      data: params,
      timeout: 300000
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 国际订单列表查询
export async function queryIntlList (params) {
  try {
    const data = await axios({
      url: '/api/userOrder/queryInt',
      method: 'post',
      data: params
    })

    const airport = await flightCities()
    // 补全城市名
    if (data && data.list) {
      data.list.forEach(element => {
        element.statusCn = orderStatusMap[element.status]

        element.segmentList.forEach(seg => {
          seg.depName = getAirportName(airport, seg.depCode)
          seg.arrName = getAirportName(airport, seg.arrCode)
        })
      })
    }

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 下单流程 - 下单
export async function submitOrder (params) {
  try {
    return await axios.post('/api/order/place', params, { timeout: 150000 })
  } catch (error) {
    return Promise.reject(error)
  }
}

// 下单GA信息获取
export async function orderDataGA (params) {
  try {
    return await axios.get('/api/order/orderDataGA', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 退票
export async function refundOrder (body) {
  try {
    const { type, refundUpLoadFilesDTOList } = body
    const data = {
      orderId: body.orderId,
      refundType: body.refundType,
      remark: body.remark,
      type: body.type,
      ifInternational: body.ifInternational
    }

    if (type === 'TICKET') {
      if (body.constraintReason) {
        data.constraintReason = body.constraintReason
      }
      if (body.orderItemServiceDetailIds && body.orderItemServiceDetailIds.length) {
        data.orderItemServiceDetailIds = body.orderItemServiceDetailIds
      }
    } else if (type === 'OTHER' || type === 'INSURANCE') {
      if (body.orderIds && body.orderIds.length) {
        data.orderItemServiceDetailIds = body.orderIds
      }
    }

    if (refundUpLoadFilesDTOList) {
      data.refundUpLoadFilesDTOList = refundUpLoadFilesDTOList
    }

    return axios.post('/api/order/refundOrder', data, { timeout: 300000 })
  } catch (error) {
    return Promise.reject(error)
  }
}

// 通用退订（支持卡券）-v2
export async function refundOrderV2 (body) {
  try {
    const { type, refundUpLoadFilesDTOList } = body
    const data = {
      ...body
    }

    if (type === 'TICKET') {
      if (body.constraintReason) {
        data.constraintReason = body.constraintReason
      }
      if (body.orderItemServiceDetailIds && body.orderItemServiceDetailIds.length) {
        data.orderItemServiceDetailIds = body.orderItemServiceDetailIds
      }
    } else if (type === 'OTHER' || type === 'INSURANCE') {
      if (body.orderIds && body.orderIds.length) {
        data.orderItemServiceDetailIds = body.orderIds
      }
    }

    if (refundUpLoadFilesDTOList) {
      data.refundUpLoadFilesDTOList = refundUpLoadFilesDTOList
    }
    return axios.post('/api/order/v2/refundOrder', data, { timeout: 300000 })
  } catch (error) {
    return Promise.reject(error)
  }
}

// 退票附件上传
export async function refundOrderUpload (data) {
  try {
    return await axios.post('/api/file/upload', data)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 更新订单乘机人信息
export async function updatePassenger (params) {
  try {
    return await axios.post('/api/order/passenger/update', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 退票补充上传材料
export async function saveUploadFiles (data) {
  try {
    return await axios.post('/api/order/saveUploadFiles', data)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 旧订单

export async function queryListV1 (params) {
  try {
    const data = await axios({
      url: '/api/userOrder/query',
      method: 'post',
      data: params
    })
    const airport = await flightCities()

    if (data && data.list) {
      data.list.forEach(element => {
        element.statusCn = orderStatusMap[element.status]

        element.segmentList.forEach(seg => {
          seg.depName = getAirportName(airport, seg.depCode)
          seg.arrName = getAirportName(airport, seg.arrCode)
        })
      })

      return data
    } else {
      return Promise.reject(new Error('订单数据异常'))
    }
  } catch (err) {
    return Promise.reject(err)
  }
}

// 订单详情
export async function queryDetailV1 (params) {
  try {
    const data = await axios({
      url: '/api/order/query',
      method: 'post',
      data: params
    })

    if (data && data.offers) {
      data.offers.forEach(element => {
        element.detail.statusCn = orderStatusMap[element.detail.status]

        if (element.detail.itinerary) {
          element.detail.itinerary.statusCn = orderStatusMap[element.detail.itinerary.status]
        }

        element.detail.travelers.forEach(traveler => {
          traveler.typeCn = travalerTypeMap[traveler.type]
          traveler.certificateTypeCn = idTypeV2Map[traveler.certificateType]

          traveler.flightSegments.forEach(seg => {
            seg.statusCn = segmentStatusMap[seg.status]
            seg.ticketStatusCn = ticketStatusMap[seg.ticketStatus]
          })
        })

        element.detail.changes.forEach(change => {
          change.statusCn = orderStatusMap[change.status]
        })

        element.detail.payments.forEach(pay => {
          pay.payStatusCn = payStatusMap[pay.payStatus]
          pay.payTypeCn = payTypeMap[pay.payType]
        })

        element.detail.refunds.forEach(refund => {
          refund.statusCn = refundStatusMap[refund.status]
        })

        element.detail.orderDuration = element.detail.orderLimit - new Date().getTime()
      })

      return data
    } else {
      return Promise.reject(new Error('订单详情数据异常'))
    }
  } catch (err) {
    return Promise.reject(err)
  }
}

// 游客订单详情查询
export async function touristQueryDetail (params) {
  try {
    const data = await axios({
      url: '/api/order/touristQuery',
      method: 'post',
      data: params
    })

    if (data && data.offers) {
      data.offers.forEach(element => {
        element.detail.statusCn = orderStatusMap[element.detail.status]

        if (element.detail.itinerary) {
          element.detail.itinerary.statusCn = orderStatusMap[element.detail.itinerary.status]
        }

        element.detail.travelers.forEach(traveler => {
          traveler.typeCn = travalerTypeMap[traveler.type]
          traveler.certificateTypeCn = idTypeV2Map[traveler.certificateType]

          traveler.flightSegments.forEach(seg => {
            seg.statusCn = segmentStatusMap[seg.status]
            seg.ticketStatusCn = ticketStatusMap[seg.ticketStatus]
          })
        })

        element.detail.changes.forEach(change => {
          change.statusCn = orderStatusMap[change.status]
        })

        element.detail.payments.forEach(pay => {
          pay.payStatusCn = payStatusMap[pay.payStatus]
          pay.payTypeCn = payTypeMap[pay.payType]
        })

        element.detail.refunds.forEach(refund => {
          refund.statusCn = refundStatusMap[refund.status]
        })

        element.detail.orderDuration = element.detail.orderLimit - new Date().getTime()
      })

      return data
    } else {
      return Promise.reject(new Error('订单详情数据异常'))
    }
  } catch (err) {
    return Promise.reject(err)
  }
}

// 订单取消
export async function cancelV1 (params) {
  try {
    return await axios({
      url: '/api/order/cancel',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 订单退订
export async function refundV1 (params) {
  const { type, orderIds } = params

  if (type === 'OTHER' || type === 'INSURANCE') {
    if (orderIds && orderIds.length) {
      params.orderItemServiceDetailIds = params.orderIds
    }
  }

  try {
    await axios({
      url: '/api/order/refund',
      method: 'post',
      data: params,
      timeout: 300000
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 改升支持校验
export async function check (params) {
  try {
    return await axios({
      url: '/api/flight/can/change/flight',
      method: 'post',
      data: params,
      timeout: 300000
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 航变校验
export async function checkBefore (params) {
  try {
    return await axios({
      url: '/api/flight/check/change/flight',
      method: 'post',
      data: params,
      timeout: 300000
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 支付差错
export async function misPay (params) {
  try {
    return await axios({
      url: '/api/payOrder/misPay',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 随票辅营订单退订
export async function refundExtProduct (params) {
  try {
    return await axios({
      url: '/api/order/extProduct/refund',
      method: 'post',
      data: params,
      timeout: 300000
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 获取权益
export async function queryBenefit (params) {
  try {
    return await axios({
      url: '/api/flight/uni/query/benefit',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 代理人导出 - 8L
export async function agentExport () {
  try {
    return await axios({
      url: '/api/userOrder/agentExport',
      method: 'get'
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 查询用户当天取消订单数量
export async function queryUserCancelOrderCount (params = {}) {
  try {
    return await axios({
      url: '/api/order/queryUserCancelOrder',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 查询是否海航员工
export async function queryIsGroupStaff (params = {}) {
  try {
    return await axios({
      url: '/api/user/iGroupStaff',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

function handleChangeSegmentFlag (segments) {
  let originSegmentIds = []
  const segGroup = groupBy(segments, (s) => s.departureCode + s.arrivalCode)

  for (const cityCode of Object.keys(segGroup)) {
    if (segGroup[cityCode].length > 1) {
      segGroup[cityCode] = orderBy(segGroup[cityCode], ['bookDate'], ['desc'])
      const originSegments = segGroup[cityCode].slice(1)
      originSegmentIds = originSegmentIds.concat(originSegments.map(seg => seg.id))
    }
  }

  segments.forEach(seg => {
    seg.isOrigin = !!originSegmentIds.includes(seg.id)
  })

  return segments
}
